import { useSearchParams } from "react-router-dom";
import { EmiWrapperComponent } from "../emiCalculator";
import { ClipboardPen } from "lucide-react";
import TablesContainer from "./table/TablesContainer";
import { getTableConfig, TABLE_TYPES } from "./config/tableConfig";

const isValidTableType = (value) => Object.values(TABLE_TYPES).includes(value);

export default function Onboarding() {
  const [searchParams] = useSearchParams();
  const tabFromUrl = searchParams.get("tab");
  const tableType = isValidTableType(tabFromUrl)
    ? tabFromUrl
    : TABLE_TYPES.LEADS;

  const config = getTableConfig(tableType);

  return (
    <EmiWrapperComponent
      title={config.title}
      subTitle={`Onboard the driver from the ${config.title.toLowerCase()} list.`}
      icon={<ClipboardPen size={50} />}
    >
      <TablesContainer />
    </EmiWrapperComponent>
  );
}
